export default __webpack_public_path__ + "static/media/Chevron-white-up.deb48bdc.svg";